import Bottle from 'bottlejs';
import terminusContainerFactory from './TerminusContainer';
import terminusViewFactory from './TerminusView';
import terminusData from './TerminusData';
import terminusAddVocabularyContainerFactory from './TerminusAddVocabularyContainer';
import vocabularyAddHelp from './VocabularyAddHelp';
import terminusSingleFieldEntryFactory from './TerminusSingleFieldEntry';

export default () => {
  const terminusBottle = new Bottle();
  terminusAddVocabularyContainerFactory(terminusBottle);
  terminusContainerFactory(terminusBottle);
  terminusViewFactory(terminusBottle);
  terminusData(terminusBottle);
  vocabularyAddHelp(terminusBottle);
  terminusSingleFieldEntryFactory(terminusBottle);
  return terminusBottle;
};
